/** The tabs of the page of an inbound in Backstage, in the order it shows them (`?tab=`). */
export const inboundTabs = [
  "lines",
  "packing",
  "check",
  "documents",
  "systems",
  "receipts",
  "outcome",
  "details",
  "notes",
  "history",
] as const;
export type InboundTab = (typeof inboundTabs)[number];
